import { DefaultService as RestApiService } from '../../../swagger-api';
import { MapFilters } from '../map.enum';
import { MapCommunityDetailsProvider } from './map-community-details.provider';
import { MapCovidDetailsProvider } from './map-covid-details.provider';
import { MapItemDetailsProvider } from './map-item-details.provider';
import { MapOrganizationDetailsProvider } from './map-organization-details.provider';
import { MapPeopleDetailsProvider } from './map-people-details.provider';
import { MapProjectDetailsProvider } from './map-project-details.provider';

export class MapItemDetailsProviderStrategy {
  public static getProvider(entity: string, apiService: RestApiService): MapItemDetailsProvider | null {
    switch (entity) {
      case MapFilters.COVID.toLowerCase():
        return new MapCovidDetailsProvider(apiService);
      case MapFilters.COMMUNITIES.toLowerCase():
        return new MapCommunityDetailsProvider(apiService);
      case MapFilters.PROJECTS.toLowerCase():
        return new MapProjectDetailsProvider(apiService);
      case MapFilters.ORGANIZATIONS.toLowerCase():
        return new MapOrganizationDetailsProvider(apiService);
      case MapFilters.PEOPLE.toLowerCase():
        return new MapPeopleDetailsProvider(apiService);
      default:
        return null;
    }
  }
}
